<template>
  <TheCatcherComponent>
    <EmbeddedSwapModal
      v-if="isNewArchitectureEnabled"
      :image
      :initial-payload
      :intro
      :modal-name
      :price
      :price-without-trade-in
      :product-title
      :redirect-on-close-target
      :zone
      @confirmation="$emit('confirmation')"
      @continue="$emit('continue')"
    />
    <EmbeddedSwapModalLegacy
      v-else
      :image
      :initial-payload
      :intro
      :modal-name
      :price
      :price-without-trade-in
      :product-title
      :redirect-on-close-target
      :zone
      @confirmation="$emit('confirmation')"
      @continue="$emit('continue')"
    />
  </TheCatcherComponent>
</template>

<script setup lang="ts">
// TODO: [FF_NEW_BUYBACK_ARCHITECTURE_COUNTRIES] Remove the feature flag branch, the legacy import,
// and the v-if/v-else once the rollout is complete. Keep only EmbeddedSwapModal.
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'
import type { LocationQuery } from 'vue-router'

import type { Price } from '@backmarket/http-api'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import TheCatcherComponent from '~/scopes/buyback/components/BuybackErrorBoundary/BuybackErrorBoundary.vue'

import EmbeddedSwapModal from '../SwapModal/SwapModal.vue'
import EmbeddedSwapModalLegacy from '../SwapModal/SwapModalLegacy.vue'

export interface SwapModalProps {
  modalName: string
  redirectOnCloseTarget?: string | null
  zone: string
  price?: Price
  priceWithoutTradeIn?: Price
  intro?: 'atc' | 'plp'
  initialPayload?: LocationQuery
  image?: GetProductResponse['images'][number]
  productTitle?: string
}

withDefaults(defineProps<SwapModalProps>(), {
  redirectOnCloseTarget: null,
  initialPayload: undefined,
  intro: undefined,
  price: undefined,
  priceWithoutTradeIn: undefined,
  image: undefined,
  productTitle: undefined,
})

defineEmits(['confirmation', 'continue'])

const { market } = useMarketplace()
const { FF_NEW_BUYBACK_ARCHITECTURE_COUNTRIES } = useRuntimeConfig().public

const isNewArchitectureEnabled = computed(() =>
  FF_NEW_BUYBACK_ARCHITECTURE_COUNTRIES.includes(market.countryCode),
)
</script>
